// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-menu.show {\n    top: 100% !important;\n    position: absolute !important;\n}\n.select-store .dropdown-menu {\n    position: relative !important;\n}\n.dropdown-menu.sf-dropdown-menu {\n    min-width: 600px;\n    background-color: #f3f3f3;\n}\n.form-control.table-searchterm-input {\n    align-self: flex-start !important;\n    margin-top: 2px !important;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
